const market = {
  dsbz: "Moedas a serem listadas",
  kpsj: "Contagem regressiva para abertura/tempo de abertura",
  ykp: "Já aberto",
  kpdjs: "Contagem regressiva para abertura",
  worning: "Não é o preço final da transação, apenas para referência",
  swapTab_1: "Contratos Perpétuos USDT",
  swapTab_2: "Contratos Perpétuos Moeda",
  searchCoin: "Buscar moeda desejada",
  risk: "Aviso de risco",
  addSelfCode: "Adicionar aos favoritos",
  pair: "Par",
  latestPrice: "Preço Atual",
  changeHour: "Variação 1h",
  highHour: "Maior 24h",
  lowHour: "Menor 24h",
  priceTrend: "Tendência de Preço (3 dias)",
  volumeHour: "Volume 24h",
  noSearch: "Nenhuma moeda encontrada",
  noAdd: "Nenhuma moeda adicionada aos favoritos",
  noYet: "Essa moeda ainda não foi listada",
  noBi: "Essa moeda ainda não foi lançada",
  wan: "dez mil", // Not sure about the context, assuming it's a unit.
  qian: "mil", // Not sure about the context, assuming it's a unit.
  yi: "cem milhões", // Not sure about the context, assuming it's a unit.
  yxhy: "Contratos Perpétuos", // Not sure about the context, assuming it's related to "Perpetual Contracts".
  wghy: "Contrato de Grade",
  cxjy: "Moedas inovadoras geralmente possuem conquistas técnicas e de mercado, mas também têm maior volatilidade e riscos. Recomendamos que você consulte informações relevantes e decida se deseja participar dentro da sua capacidade de suportar riscos.",
  qljy: "A área de negociação potencial ainda está em fase inicial de desenvolvimento no mercado, e o BiKing não pode garantir nenhum consenso de valor ou circulação de mercado. Por favor, examine cuidadosamente as informações do projeto e participe do investimento de forma prudente dentro da sua capacidade de suportar riscos.",
  qljyDao:
    "A área de negociação DAO ainda está em fase inicial de desenvolvimento no mercado, e o BiKing não pode garantir nenhum consenso de valor ou circulação de mercado. Por favor, examine cuidadosamente as informações do projeto e participe do investimento de forma prudente dentro da sua capacidade de suportar riscos.",
  default:
    "A área de negociação ainda está em fase inicial de desenvolvimento no mercado, e o BiKing não pode garantir nenhum consenso de valor ou circulação de mercado. Por favor, examine cuidadosamente as informações do projeto e participe do investimento de forma prudente dentro da sua capacidade de suportar riscos.",
  storage:
    "A área de negociação de armazenamento ainda está em fase inicial de desenvolvimento no mercado, e o BiKing não pode garantir nenhum consenso de valor ou circulação de mercado. Por favor, examine cuidadosamente as informações do projeto e participe do investimento de forma prudente dentro da sua capacidade de suportar riscos.",
  dlt: "A área de negociação de baixa liquidez possui baixa circulação no mercado, o que pode acarretar em deslistagem. Recomendamos que você considere cuidadosamente antes de participar do investimento.",
  defi: "A área de negociação DeFi ainda está em fase inicial de desenvolvimento no mercado, e o BiKing não pode garantir nenhum consenso de valor ou circulação de mercado. Por favor, examine cuidadosamente as informações do projeto e participe do investimento de forma prudente dentro da sua capacidade de suportar riscos.",
  nft: "A área de negociação NFT ainda está em fase inicial de desenvolvimento no mercado, e o BiKing não pode garantir nenhum consenso de valor ou circulação de mercado. Por favor, examine cuidadosamente as informações do projeto e participe do investimento de forma prudente dentro da sua capacidade de suportar riscos.",
  hz: "Perpétuo",
  yx: "Selecionado",
  yjyzx: "Projetos Selecionados pelo Instituto de Pesquisa",
  zx: "Favoritos",
  bb: "Spot",
  hy: "Contrato",
  zfb: "Ranking de Aumento",
  xbb: "Ranking de Novas Moedas",
  bd: "Par",
  zxj: "Preço Atual",
  zdf24: "Variação 24h",
  high24: "Maior 24h",
  low24: "Menor 24h",
  turnover24: "Volume 24h",
  zd24: "Variação 24h",
  zjrzd: "Preço/Variação Diária",
  scgl: "Visão geral do mercado",
  jysj: "Dados de transação",
  fyje: "Valor da comissão",
  推荐链接:'Link',
  一键分享:'Compartilhar',
  不允许任何用户通过多:"Devido a alterações no ambiente de mercado, à existência de riscos de fraude e outros motivos, a Biking reserva-se o direito final de proceder a ajustes nas regras de descontos a qualquer momento.",
  交易人数: "Número de comerciantes",
  使用你的推荐链接:"Os utilizadores que se registem utilizando o seu link de referência ou código de referência são considerados seus convidados. o código de indicação no momento do registo, a relação de convite não será estabelecida;",
  保留对活动的最终解释权: ' Se tiver alguma dúvida, contacte o serviço de apoio ao cliente.',
  合约交易返佣: "Obtenha descontos em transações contratuais de alto valor",
  合约手续费: "Taxa de tratamento do contrato ",
  合约返佣: "Desconto de comissão acumulada no contrato",
  好友返佣比例: "Proporção de desconto de amigos",
  我的返佣比例: "A minha taxa de desconto",
  推荐人数: "Número de referências",
  推荐好友: "Recomendar amigos",
  推荐: "Recomendar",
  推荐总览: "Visão geral da recomendação ",
  推荐码: "Código recomendação",
  推荐记录: "Registo de recomendação",
  是否交易: "Se negociar",
  注册时间: "Tempo de registo (UTC+8)",
  用户邀请朋友无上限:"Devido a alterações no ambiente de mercado, à existência de riscos de fraude e outros motivos, a Biking reserva-se o direito final de fazer ajustes nas regras de desconto a qualquer momento. ",
  由于市场环境的改变: 'Devido a alterações no ambiente de mercado, à existência de riscos de fraude e outros motivos, a Biking reserva-se o direito final de proceder a ajustes nas regras de descontos a qualquer momento.',
  被邀请人产生的真实交易手续费:"Pelas taxas de transação reais geradas pelo convidado, o convidante pode receber uma comissão correspondente à taxa de transação, que será devolvida à conta do convidante no dia seguinte. O horário específico de depósito será após as 4 horas de cada dia.",
  邀请人只有进行合约:"O. se auto-convidar através de múltiplas contas. a taxa de gestão da conta convidada será reembolsada será cancelada",
  请输入账户UID: "Introduza o UID da conta",
  账户UID: "UID da conta",
  返佣活动规则说明: "Descrição das regras de atividade de descontos:",
  返佣记录: "Registo de desconto",
  ms: "Sim",
  mf: "Não",
};

export { market };



// WEBPACK FOOTER //
// ./src/i18n/lang/market/pt_BR.js